import classes from "./FollowUs.module.scss";
import getSiteNavSchema from "@Components/FooterV2/util";
import chinaSocialMediaData from "./chinaSocialMediaData";
import LazyImage from "@Components/Image";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import getQueryParams from "helpers/getQueryParams";
import useCustomWindowOpen from "@Components/CustomWindowOpen";

const FollowUsChina = () => {
  const customWindowOpen = useCustomWindowOpen();
  const handleRedirect = (link: string) => {
    customWindowOpen({ url: link, target: "_blank", isExternal: true });
  };

  const { t } = useTranslationHook();
  const { utm_source = "" } = getQueryParams();
  const socialMedia =
    utm_source === "douyin_ads" ? [chinaSocialMediaData[1]] : chinaSocialMediaData;
  return (
    <div className={classes.outerDivChina}>
      <div className={classes.label}>{t("home.footer.followus")}:</div>

      <div className={classes.innerDivChina}>
        {socialMedia.map((media: any) => (
          <div className={classes.linkedIn} key={media.id}>
            <script
              type="application/ld+json"
              suppressHydrationWarning
              dangerouslySetInnerHTML={{ __html: getSiteNavSchema(media.name, media.link) }}
            />
            <LazyImage
              src={media.icon}
              alt={media.name}
              className={classes.mediaImg}
              onClick={() => handleRedirect(media.link)}
              height={22}
              width={22}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default wrapperHOC(FollowUsChina, {
  componentName: "FollowUsChina-FooterV2-Global",
  showForChina: true,
});
